import {
  BaseInput,
  Button,
  Chip,
  Dropdown,
  FormField,
  FormFieldControl,
  FormFieldLabel,
  tk,
} from '@sunwebgroup/ui-components'
import { css, styled } from 'styled-components'

const Root = styled(FormField)`
  min-width: 234px;
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
`

const Label = styled(FormFieldLabel)``

const Control = styled(FormFieldControl)<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled
    && css`
      pointer-events: none;
      ${BaseInput.modDisabled()}
      ${Dropdown.modDisabled()}
      ${Chip} {
        ${Chip.modDisabled()}
      }
    `}
  ${BaseInput.Box}, ${Dropdown} {
    height: 48px;
  }
  ${Dropdown} {
    align-items: center;
    select {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
`

export const CloseButton = styled(Button)`
  width: 100%;
`

export const Footer = styled.div`
  padding: ${tk('spacing_md')} ${tk('spacing_lg')};
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  background-color: ${tk('color_semantic_bg')};
  z-index: 1;
`

export const PricesFilter = {
  Root,
  Label,
  Control,
  Footer,
  CloseButton,
}
